import { MessageCircleMore, Clock3, SearchX } from 'lucide-react';

const problems = [
  {
    icon: MessageCircleMore,
    title: 'Cererile vin din prea multe locuri',
    text: 'Facebook, WhatsApp, telefon sau formular. Când totul este împărțit în mai multe locuri, devine ușor să pierzi lead-uri bune.',
  },
  {
    icon: Clock3,
    title: 'Răspunsul întârzie și clientul merge mai departe',
    text: 'Mulți clienți întreabă în mai multe locuri în paralel. Dacă nu găsesc rapid informațiile sau nu primesc un răspuns clar, aleg altă variantă.',
  },
  {
    icon: SearchX,
    title: 'Businessul tău nu arată suficient de clar online',
    text: 'Fără o prezentare bună și un flux simplu pentru cereri, chiar și interesul existent se transformă mai greu în rezervări sau programări directe.',
  },
];

export default function ProblemsSection() {
  return (
    <section className="rz-section rz-section--light" id="problema">
      <div className="rz-shell">
        <div className="rz-problems-wrap">
          <div className="rz-section-heading rz-section-heading--split">
            <div>
              <p className="rz-kicker rz-kicker--dark">Problema</p>
              <h2>De multe ori nu îți lipsesc cererile. Îți lipsește un mod mai clar de a le capta și organiza.</h2>
            </div>
            <p>
              Rezervix nu promite trafic din nimic. Te ajută să transformi mai bine interesul pe care îl ai deja într-un flux clar, profesionist și ușor de gestionat.
            </p>
          </div>

          <div className="rz-problems-grid">
            {problems.map((item) => {
              const Icon = item.icon;
              return (
                <article key={item.title} className="rz-problem-card">
                  <div className="rz-problem-card__icon">
                    <Icon size={22} />
                  </div>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
